// WP6-B.5 — Marketing About tab. Ported verbatim from the live Studio G4 pod's
// `AdminAbout.js`. Only mechanical adjustment: `../../lib/api` → `./marketingAdminApi`.
// The About tab deliberately omits the image upload UI; the About image slot lives
// in the Site Images tab per user instruction (dispatch §3.3).
import React, { useState, useEffect } from "react";
import { adminGetAbout, adminUpdateAbout } from "./marketingAdminApi";
import { Input } from "../../../components/ui/input";
import RichTextEditor from "../../../components/RichTextEditor";
import { Save } from "lucide-react";

export default function MarketingAbout() {
    const [form, setForm] = useState({ headline: "", description: "", mission: "", vision: "", image: "" });
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        adminGetAbout().then((data) => setForm(data)).catch(() => {});
    }, []);

    const handleSave = async () => {
        setSaving(true);
        try {
            await adminUpdateAbout(form);
            setSaved(true);
            setTimeout(() => setSaved(false), 2000);
        } catch (e) {
            console.error(e);
        }
        setSaving(false);
    };

    return (
        <div data-testid="admin-about-page" className="p-8 md:p-12">
            <div className="flex items-center justify-between mb-10">
                <div>
                    <h1 className="font-['Outfit'] text-2xl tracking-tight text-[#0A0A0A]">About</h1>
                    <p className="text-sm text-[#525252] mt-1">Edit your studio's information</p>
                </div>
                <button
                    onClick={handleSave}
                    data-testid="save-about-btn"
                    disabled={saving}
                    className="btn-studio px-6 py-2.5 text-sm tracking-wide font-medium inline-flex items-center gap-2 disabled:opacity-50"
                >
                    <Save size={16} /> {saving ? "Saving..." : saved ? "Saved!" : "Save Changes"}
                </button>
            </div>

            <div className="max-w-3xl space-y-8">
                <div>
                    <label className="text-xs tracking-[0.1em] uppercase font-bold text-[#0A0A0A] mb-2 block">Headline</label>
                    <Input
                        data-testid="about-headline-input"
                        value={form.headline}
                        onChange={(e) => setForm({ ...form, headline: e.target.value })}
                        className="rounded-none border-[#E5E5E5] h-12"
                        placeholder="e.g., Crafting Spaces That Inspire"
                    />
                </div>
                <div>
                    <label className="text-xs tracking-[0.1em] uppercase font-bold text-[#0A0A0A] mb-2 block">Description</label>
                    <RichTextEditor
                        content={form.description}
                        onChange={(html) => setForm((prev) => ({ ...prev, description: html }))}
                        placeholder="Tell visitors about your studio..."
                    />
                </div>
                <div>
                    <label className="text-xs tracking-[0.1em] uppercase font-bold text-[#0A0A0A] mb-2 block">Mission</label>
                    <RichTextEditor
                        content={form.mission}
                        onChange={(html) => setForm((prev) => ({ ...prev, mission: html }))}
                        placeholder="Your mission statement..."
                    />
                </div>
                <div>
                    <label className="text-xs tracking-[0.1em] uppercase font-bold text-[#0A0A0A] mb-2 block">Vision</label>
                    <RichTextEditor
                        content={form.vision}
                        onChange={(html) => setForm((prev) => ({ ...prev, vision: html }))}
                        placeholder="Your vision..."
                    />
                </div>
            </div>
        </div>
    );
}
